<!-- 开屏广告 -->
<template>
    <div>
        <el-dialog
            :footer="null"
            :close-on-press-escape="false"
            append-to-body
            :title="null"
            :show-close="false"
            :visible="visible"
            :close-on-click-modal="false"
            class="open-ads"
            width="90vw"
            center
            :custom-class="dialogCustomClass"
        >
            <div class="wrapper">
                <div
                    class="img-wrapper"
                    @mouseenter="handleImageMouseEnter"
                    @mouseleave="handleImageMouseLeave"
                >
                    <div class="close-btn" v-show="!isHoveringImage">
                        <span class="small-font">
                            {{ time ? time + "s" : "" }}
                        </span>
                        后关闭
                    </div>
                    <div
                        v-show="isHoveringImage"
                        class="manual-close-btn"
                        @click.stop="handleManualClose"
                    >
                        关闭
                    </div>
                    <el-image
                        :src="showAdsDisplayUrl"
                        alt=""
                        class="img"
                        @load="handleImgLoad"
                        @error="handleImgLoadError"
                        @click="handleImageClick"
                    />
                </div>
            </div>
        </el-dialog>
        <el-drawer
            title="详情"
            :visible.sync="pdfVisible"
            :withHeader="false"
            size="50%"
            append-to-body
        >
            <div class="bar">
                <DialogFooter
                    @confirm="handlePre()"
                    @cancel="handleNext()"
                    showTab="NB"
                    :confirmOptions="{
                        size: 'small',
                    }"
                    :cancelOptions="{
                        size: 'small',
                    }"
                    cancelText="下一个"
                    style="gap: 10px; justify-content: flex-start"
                    confirmText="上一个"
                    top="0"
                ></DialogFooter>
                <DialogFooter
                    @confirm="goToDetail()"
                    @cancel="handleDetailClose"
                    showTab="NB"
                    :confirmOptions="{
                        size: 'small',
                    }"
                    :cancelOptions="{
                        size: 'small',
                    }"
                    cancelText="关闭"
                    style="gap: 10px; justify-content: flex-end"
                    confirmText="网页显示"
                    top="0"
                ></DialogFooter>
            </div>
            <PdfView
                :url="showAdsInfo.pdfUrl"
                style="height: calc(100% - 50px)"
            />
        </el-drawer>
        <div
            class="small-window"
            v-if="!visible && !pdfVisible && smallVisible"
        >
            <div class="small-window-container">
                <span class="close-btn" @click.stop="handleCloseSmallWindow">
                    X
                </span>
                <img
                    :src="showAdsDisplayUrl"
                    alt=""
                    class="img"
                    @click="handleSmallWindowImageClick"
                />
            </div>
        </div>
        <!-- 图片放大预览 -->
        <el-dialog
            :visible.sync="previewVisible"
            :title="null"
            :show-close="false"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            append-to-body
            fullscreen
            custom-class="image-preview-dialog"
            @close="previewVisible = false"
        >
            <div class="preview-wrapper" @click.self="previewVisible = false">
                <img :src="previewImageUrl" class="preview-img" @click.stop />
                <span class="preview-close-btn" @click="previewVisible = false">
                    ×
                </span>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// 打开详情的key
const OPEN_KEY = `open_ads`;
const ADS_JSON_URL =
    "https://web.nbhuojian.com/static/fangcangwang/ads/ads.json";
import PdfView from "../common/PdfView.vue";
import DialogFooter from "@/components/layout/DialogFooter.vue";
import { adClick, adClose } from "@/api/common";
import { apiCallback } from "@/utils";
import bus from "@/utils/bus.js";

export default {
    name: "OpenAds",
    components: {
        PdfView,
        DialogFooter,
    },
    computed: {
        dialogCustomClass() {
            let result = "custom-open-ads";
            if (this.showAdsInfo.direction === "vertical") {
                result += " vertical";
            } else {
                result += " horizontal";
            }
            return result;
        },
        // 参与开屏轮播的广告：未隐藏，且后台「加入轮播」不为否（缺省视为加入）
        carouselAds() {
            return this.adsList.filter((item) => this.isJoinCarousel(item));
        },
    },
    data() {
        return {
            visible: false,
            adsList: [], // 从 OSS ads.json 拉取，带时间戳请求
            showAdsInfo: {
                url: "",
                pdfUrl: ``,
                title: "",
            },
            time: 3,
            pdfVisible: false,
            smallVisible: false,
            curShowIndex: 0,
            showDetailAdId: "", // 点击显示广告详情后，记录的广告id
            showDetailStartTime: 0, // 点击显示广告详情，记录的时间
            isHoveringImage: false, // 鼠标是否在图片上（用于暂停倒计时）
            previewVisible: false, // 图片放大预览弹窗
            previewImageUrl: "", // 预览图片地址
            showAdsDisplayUrl: "", // 展示用图片地址（带时间戳，仅在切换广告时更新）
        };
    },
    created() {
        this.fetchAdsList();
        bus.$on("open-zdx-detail", () => {
            const cacheAdIndex = this.adsList.findIndex(
                (item) => item.key === "zhidingxiang",
            );
            if (cacheAdIndex === -1) return;
            this.setShowAdsInfo(this.adsList[cacheAdIndex], cacheAdIndex);
            this.$nextTick(() => {
                this.handleDetail();
            });
        });
        bus.$on("router-change", (data) => {
            // const showSmallWindow = ["/logistics", "/shipSubscrib","/boxquery","/manifestQuery","/classAnalysis"]
            const showSmallWindow = [];
            if (showSmallWindow.includes(data.to.path)) {
                this.smallVisible = true;
            } else {
                this.smallVisible = false;
            }
        });
    },
    methods: {
        // 从 OSS 获取广告配置（带时间戳避免缓存）
        fetchAdsList() {
            const url = `${ADS_JSON_URL}${
                ADS_JSON_URL.indexOf("?") >= 0 ? "&" : "?"
            }t_=${Date.now()}`;
            fetch(url)
                .then((res) => res.json())
                .then((data) => {
                    const list = Array.isArray(data)
                        ? data
                        : data.list || data.data || [];
                    this.adsList = list;
                    if (list.length && this.getNavigationType() !== "reload") {
                        this.calNeedShowAds();
                    }
                })
                .catch(() => {
                    this.adsList = [];
                });
        },
        // 给图片 URL 加时间戳，拉取最新图（OSS 无时间戳时用）
        getImageUrlWithTimestamp(url) {
            if (!url) return "";
            const sep = url.indexOf("?") >= 0 ? "&" : "?";
            return `${url}${sep}t_=${Date.now()}`;
        },
        // 获取页面加载类型
        getNavigationType() {
            if (window.performance && window.performance.getEntriesByType) {
                const navigationEntry =
                    window.performance.getEntriesByType("navigation")[0];
                if (navigationEntry) {
                    return navigationEntry.type; // 返回 'navigate', 'reload', 'back_forward', 'prerender'
                }
            }
            // 兼容旧版浏览器
            if (window.performance && window.performance.navigation) {
                const type = window.performance.navigation.type;
                if (type === 0) return "navigate"; // 正常导航
                if (type === 1) return "reload"; // 刷新
                if (type === 2) return "back_forward"; // 前进/后退
            }
            return "navigate"; // 默认返回普通导航
        },
        handleImgLoad() {
            this.time = 3;
            this.startCountdown();
        },
        // 开始/恢复倒计时
        startCountdown() {
            if (this.timer) clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.time--;
                if (this.time === 0) {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.visible = false;
                    if (this.showAdsInfo.key === "zhidingxiang") {
                        bus.$emit("open-zdx-btn");
                    }
                }
            }, 1000);
        },
        // 鼠标移入图片区域：暂停倒计时
        handleImageMouseEnter() {
            this.isHoveringImage = true;
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        // 鼠标移出图片区域：恢复倒计时
        handleImageMouseLeave() {
            this.isHoveringImage = false;
            if (this.time > 0 && this.visible) {
                this.startCountdown();
            }
        },
        // 手动关闭开屏广告
        handleManualClose() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
            this.visible = false;
            if (this.showAdsInfo.key === "zhidingxiang") {
                bus.$emit("open-zdx-btn");
            }
        },
        // 主弹窗内图片点击：按优先级 pathName → path → pdfUrl → clickPreview
        handleImageClick() {
            this.handleAdImageClick();
        },
        // 左下角小窗图片点击
        handleSmallWindowImageClick() {
            this.handleAdImageClick();
        },
        // 统一点击逻辑：pathName 跳转 → path 跳转 → pdfUrl 打开弹窗 → clickPreview 大图预览
        handleAdImageClick() {
            const ad = this.showAdsInfo;
            if (ad.pathName) {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.visible = false;
                this.$router.push({ name: ad.pathName });
                return;
            }
            if (ad.path) {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.visible = false;
                this.$router.push(ad.path);
                return;
            }
            if (ad.pdfUrl) {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.visible = false;
                this.pdfVisible = true;
                this.handleAdClick();
                return;
            }
            if (ad.clickPreview) {
                this.previewImageUrl = this.getImageUrlWithTimestamp(ad.url);
                this.previewVisible = true;
                return;
            }
        },
        handleImgLoadError() {
            this.handleImgLoad();
            this.smallVisible = false;
        },
        // 后台「加入轮播」：false 不参与；未配置时默认参与，与管理端一致
        isJoinCarousel(item) {
            if (!item || item.hidden === true || item.hidden === "true") {
                return false;
            }
            const carousel = item.carousel;
            if (
                carousel === false ||
                carousel === "false" ||
                carousel === 0 ||
                carousel === "0"
            ) {
                return false;
            }
            return true;
        },
        open() {
            // 测试环境不展示广告
            if (process.env.NODE_ENV === "production") {
                setTimeout(() => {
                    const navigationType = this.getNavigationType();
                    if (
                        navigationType !== "reload" &&
                        this.carouselAds.length &&
                        this.showAdsInfo &&
                        this.showAdsInfo.url
                    ) {
                        this.visible = true;
                        this.smallVisible = true;
                    }
                }, 1000);
            }
        },
        // 格式化数据(默认值)
        formatData() {
            if (!this.adsList.length) return;
            this.setShowAdsInfo(this.adsList[0], 0);
            this.smallVisible = true;
        },
        // 计算需要显示的广告（只在「加入轮播」的广告里轮换）
        calNeedShowAds() {
            const cacheAdList = this.carouselAds;
            if (!cacheAdList.length) return;
            const lastShowAdKey = localStorage.getItem("fcw_lastShowAdKey");
            // 获取当前查看的次数
            if (!lastShowAdKey) {
                localStorage.setItem("fcw_lastShowAdKey", cacheAdList[0].key);
                this.curShowIndex = 0;
                this.setShowAdsInfo(cacheAdList[0], 0);
                return;
            } else {
                const lastShowAdIndex = cacheAdList.findIndex(
                    (item) => item.key === lastShowAdKey,
                );
                if (lastShowAdIndex === -1) {
                    localStorage.setItem(
                        "fcw_lastShowAdKey",
                        cacheAdList[0].key,
                    );
                    this.curShowIndex = 0;
                    this.setShowAdsInfo(cacheAdList[0], 0);
                    return;
                } else {
                    const newIndex = lastShowAdIndex + 1;
                    if (newIndex < cacheAdList.length) {
                        this.curShowIndex = newIndex;
                        this.setShowAdsInfo(cacheAdList[newIndex], newIndex);
                        localStorage.setItem(
                            "fcw_lastShowAdKey",
                            cacheAdList[newIndex].key,
                        );
                    } else {
                        localStorage.setItem(
                            "fcw_lastShowAdKey",
                            cacheAdList[0].key,
                        );
                        this.curShowIndex = 0;
                        this.setShowAdsInfo(cacheAdList[0], 0);
                    }
                }
            }
        },
        // 设置当前展示的广告，并生成带时间戳的图片地址
        setShowAdsInfo(item, index) {
            this.showAdsInfo = item;
            this.curShowIndex = index;
            this.showAdsDisplayUrl = this.getImageUrlWithTimestamp(
                item ? item.url : "",
            );
        },
        handleCloseSmallWindow() {
            this.smallVisible = false;
        },
        handleClose() {
            if (this.time) return;
            this.visible = false;
        },
        // 广告点击
        handleAdClick() {
            this.showDetailAdId = "";
            this.showDetailStartTime = new Date().getTime();
            if (this.$store.state.user.token) {
                adClick({
                    adName: this.showAdsInfo.title,
                }).then((res) => {
                    const data = apiCallback(res);
                    this.showDetailAdId = data;
                });
            }
        },

        handleDetail() {
            this.handleAdImageClick();
        },
        goToDetail() {
            if (this.showAdsInfo.pdfUrl) {
                window.open(this.showAdsInfo.pdfUrl);
            }
            this.handleAdClose(true);
        },
        // 详情里上一个 / 下一个，同样只在轮播广告中切换
        getCarouselIndex(offset) {
            const list = this.carouselAds;
            if (!list.length) return -1;
            const index = list.findIndex(
                (item) => item.key === this.showAdsInfo.key,
            );
            if (index === -1) {
                return offset >= 0 ? 0 : list.length - 1;
            }
            return (index + offset + list.length) % list.length;
        },
        handleNext() {
            const list = this.carouselAds;
            const nextIndex = this.getCarouselIndex(1);
            if (nextIndex < 0) return;
            this.setShowAdsInfo(list[nextIndex], nextIndex);
            this.$nextTick(() => {
                this.handleAdClose().then(() => {
                    this.handleAdClick();
                });
            });
        },
        handlePre() {
            const list = this.carouselAds;
            const preIndex = this.getCarouselIndex(-1);
            if (preIndex < 0) return;
            this.setShowAdsInfo(list[preIndex], preIndex);
            this.$nextTick(() => {
                this.handleAdClose().then(() => {
                    this.handleAdClick();
                });
            });
        },
        // 广告关闭或切换
        handleAdClose(newPageAd = false) {
            return new Promise((resolve, reject) => {
                if (this.showDetailAdId) {
                    // 点击的时候记录成功拿到id才执行此处逻辑
                    const endTime = new Date().getTime();
                    const stayTime = endTime - this.showDetailStartTime;
                    adClose({
                        adId: this.showDetailAdId,
                        stayTime: newPageAd ? 0 : stayTime,
                    }).finally(() => {
                        this.showDetailAdId = "";
                        this.showDetailStartTime = 0;
                        resolve();
                    });
                } else {
                    resolve();
                }
            });
        },
        handleDetailClose() {
            this.handleAdClose();
            this.pdfVisible = false;
        },
    },
};
</script>
<style lang="stylus">
.open-ads .el-dialog__body{
    padding:0;

}

.open-ads .el-dialog__header{
    padding:0
}
</style>

<style lang="stylus">
@keyframes shake {
    10% {
        transform: rotate(15deg);
      }
      20% {
        transform: rotate(-10deg);
      }
      30% {
        transform: rotate(5deg);
      }
      40% {
        transform: rotate(-5deg);
      }
      50%,100% {
        transform: rotate(0deg);
      }
}

.custom-open-ads{
    border-radius:25px;
    overflow: hidden;
    background-color: transparent;
    border: none;
    box-shadow: none;
    .wrapper{
        display: flex;
        justify-content: center;
        align-items: center;
        .img-wrapper{
            position: relative;
            .el-image__error{
                min-height: 50vh;
            }
            img{
                // border-radius:25px;
                overflow: hidden;
            }
            .manual-close-btn{
                position: absolute;
                right: 12px;
                top: 12px;
                z-index: 10;
                padding: 6px 14px;
                color: #fff;
                background-color: rgba(0, 0, 0, 0.5);
                border-radius: 4px;
                font-size: 14px;
                cursor: pointer;
                transition: all 0.3s ease;
                &:hover{
                    background-color: rgba(0, 0, 0, 0.7);
                }
            }
        }
    }
    &.vertical{
        margin-top: 5vh !important;
        .wrapper{
            .img-wrapper{
                .el-image{
                    height: 90vh;
                    width: auto;
                }
                img{
                    height: 100%;
                    border-radius:4px;
                }
            }
        }
    }
    &.horizontal{
        .wrapper{
            .el-image{
                height: 70vh;
                width: 100%;
            }
            img{
                border-radius:15px;
                width: 100%;
                height:100%;
            }
        }
    }
}

.wrapper{
    position: relative; width: 100%;
}

.bar{
    padding:5px 10px;
    display:flex;
    justify-content:space-between;
}



.small-window{
    position:fixed;
    bottom:40px;
    left:30px;
    background: #fff;
    box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 );
    backdrop-filter: blur( 4px );
    -webkit-backdrop-filter: blur( 4px );
    display:flex;
    flex-direction:column;
    justify-content:flex-end;
    border-radius: 6px;
    border: 1px solid rgba( 255, 255, 255, 0.18 );
    cursor:pointer;
    animation: shake 2.5s .15s linear infinite;
    z-index: 999;
    &:hover{
        animation-play-state: paused;
        transform: rotate(0deg);
    }
    .title{
        padding-left:5px;
        font-size:12px;
        margin-bottom:5px;
        color:#b87100;
        font-weight:bold;
    }
    .close-btn{
        position:absolute;
        right:5px;
        top:5px;
        z-index:999;
        width:16px;
        height:16px;
        display:flex;
        align-items:center;
        justify-content:center;
        color:#fff;
        background-color:rgba(0, 0, 0, 0.5);
        border-radius:50%;
        font-size:12px;
        font-weight:bold;
        cursor:pointer;
        transition:all 0.3s ease;
        line-height:1;
        &:hover{
            background-color:rgba(128, 128, 128, 0.6);
            transform:scale(1.1);
        }
        &:active{
            transform:scale(0.95);
        }
        .small-font{
            font-size:10px;
        }
    }
    .img{
        width:110px;
        max-height:130px;
        overflow:hidden;
        border-radius:6px;
        display:block;
    }
}

.image-preview-dialog{
    background: rgba(0, 0, 0, 0.85);
    margin: 0 !important;
    .el-dialog__header{
        padding: 0;
        display: none;
    }
    .el-dialog__body{
        padding: 0;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .preview-wrapper{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: zoom-out;
    }
    .preview-img{
        max-width: 95vw;
        max-height: 95vh;
        object-fit: contain;
    }
    .preview-close-btn{
        position: fixed;
        right: 24px;
        top: 24px;
        z-index: 2001;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        font-size: 28px;
        line-height: 1;
        cursor: pointer;
        transition: all 0.3s ease;
        &:hover{
            background-color: rgba(0, 0, 0, 0.8);
        }
    }
}
</style>
